import React from "react";
import PropTypes from "prop-types";
import { useParams, useNavigate } from "react-router-dom";
import { IconButton, Tooltip, Stack, Icon } from "investira.react.components";
import withPreview from "../../../hoc/withPreview";
import { formats, dates, validators } from "investira.sdk";
import { BulkContextActions, DataTable } from "../";
import services from "../../../services";
import useAcesso from "../../../hooks/useAcesso";
import { OUTPUT } from "../../../enums";

const RelatoriosDataGrid = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { podeEditarAprovar } = useAcesso();

  const {
    state,
    data,
    columns,
    renderDetailPanel,
    onBulkDeleteClick,
    ...restProps
  } = props;

  const OUTPUT_ID = OUTPUT[params.output]?.output_id;

  function onDownload(pOutput, pType) {
    const { output_cache_id, files_name, files_created } = pOutput;

    if (output_cache_id && files_created) {
      services.outputs.download(
        {
          output_cache_id,
          type: pType,
        },
        (rRes) => {
          let xOutputFilename = `${files_name}.${pType}`;
          const xFileURL = URL.createObjectURL(rRes.data);
          let xLinkElem = document.createElement("a");
          xLinkElem.href = xFileURL;
          xLinkElem.download = xOutputFilename;
          xLinkElem.click();
        },
        (rErr) => {
          console.log(rErr);
        }
      );
    }
  }

  function onPreview(pRow) {
    const { output_cache_id } = pRow.original;
    const xOutput = params.output;
    return navigate({
      pathname: `/reports/${xOutput}/${output_cache_id}`,
      search: "?completed=true",
    });
  }

  const xDataFormated = (pData) => {
    const xResult = pData.map((xRow) => {
      return {
        ...xRow,
        carteira: xRow.request_metadata.carteira,
        posicao: xRow.request.data
          ? formats.formatDate(dates.toDate(xRow.request.data))
          : "Ausente",
      };
    });
    return xResult;
  };

  const xProps = {
    columns,
    state,
    enableFacetedValues: true,
    enableRowSelection: podeEditarAprovar(OUTPUT_ID),
    renderTopToolbarCustomActions: ({ table }) => {
      if (!podeEditarAprovar(OUTPUT_ID)) {
        return null;
      }

      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;

      return (
        <BulkContextActions
          onDeleteClick={() => {
            onBulkDeleteClick(selectedRows);
          }}
          disabled={
            state.isLoading || state.showProgressBars || !isSomeRowSelected
          }
        />
      );
    },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "",
      },
    },
    renderRowActions: ({ row }) => {
      const {
        processamento_evento,
        processamento_arquivo,
        processamento_erros,
        log_id,
      } = row.original;

      const isDisabled = !(
        processamento_evento === "LF" && validators.isNull(processamento_erros)
      );

      return (
        <Stack direction="row" spacing={1}>
          <Tooltip title="Visualizar">
            <span>
              <IconButton color="primary" onClick={() => onPreview(row)}>
                <Icon iconName="eye" size={24} />
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip title="Download">
            <span>
              <IconButton
                color="primary"
                onClick={() => onDownload(row.original, "pdf")}
                disabled={!Boolean(row.original.files_created)}
              >
                <Icon iconName="download" size={24} />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      );
    },
    ...restProps,
  };

  return <DataTable {...xProps} data={xDataFormated(data)} />;
};

RelatoriosDataGrid.propTypes = {
  initialState: PropTypes.object,
};

RelatoriosDataGrid.propTypes = {
  initialState: PropTypes.object,
};

RelatoriosDataGrid.displayName = "RelatoriosDataGrid";

export default withPreview(RelatoriosDataGrid);
